import { SsrContext } from '@fergdigitalcommerce/fergy-react-components';
import { useContext, type FunctionComponent } from 'react';
import { useNavigation } from '../hooks/navigation/navigation.hooks';
import { doesWindowExist } from '../utils/dom/dom.utils';
import { PageLoading } from './common-components/loading/loading.component';

type RedirectWithStatusProps = {
	status?: number;
	to: string;
};

/**
 * Allows one to redirect with a specific status code. By default it will use 302.
 */
export const RedirectWithStatus: FunctionComponent<RedirectWithStatusProps> = ({ status, to }) => {
	const ssrContext = useContext(SsrContext);
	const navigate = useNavigation();

	if (!doesWindowExist()) {
		// SSR: communicate we want to redirect via our context
		ssrContext.url = to;
		ssrContext.statusCode = status;
	} else {
		// use navigation hook on client side redirects
		navigate(to, true);
	}

	return <PageLoading />;
};
